import { render, staticRenderFns } from "./newGroupMember.vue?vue&type=template&id=25738b46"
import script from "./newGroupMember.vue?vue&type=script&lang=js"
export * from "./newGroupMember.vue?vue&type=script&lang=js"
import style0 from "./newGroupMember.vue?vue&type=style&index=0&id=25738b46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports